import {
  fromUnixTime,
  isAfter,
  isBefore,
  isToday,
  isTomorrow,
  format,
  differenceInSeconds,
} from "date-fns";
import React, { useState, useEffect } from "react";

export const TourneyTimer = React.memo(
  ({
    tourneyStartTime,
    lateRegEndTime,
    lateRegistrationAllowed,
    lateRegEnded,
    showLateRegCountdown = false,
  }) => {
    const now = new Date();

    const startTime =
      tourneyStartTime != null ? fromUnixTime(tourneyStartTime) : null;
    const lateRegET =
      lateRegEndTime != null ? fromUnixTime(lateRegEndTime) : null;

    const [timeLeft, setTimeLeft] = useState("");

    useEffect(() => {
      if (!lateRegET) return;

      const interval = setInterval(updateTimer, 1000);
      return () => clearInterval(interval);
    }, [lateRegET]);

    const updateTimer = () => {
      if (!lateRegET) {
        setTimeLeft(false);
        return;
      }

      const now = new Date();
      const totalSeconds = differenceInSeconds(lateRegET, now);

      if (totalSeconds <= 0) {
        setTimeLeft(false);
        return;
      }

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      // Format the time as 00:00:00
      setTimeLeft(
        hours > 0
          ? `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
              2,
              "0"
            )} h`
          : minutes > 0
          ? `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
              2,
              "0"
            )} m`
          : `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
              2,
              "0"
            )} s`
      );
    };

    // Early return if startTime is null/undefined
    if (!startTime) {
      return <div>Tournament time not available</div>;
    }

    // Fallback for future date
    const dateFormatted = format(startTime, "MMM do");
    const timeFormatted = format(startTime, "hh:mm a");

    return lateRegistrationAllowed &&
      !lateRegEnded &&
      lateRegET &&
      isBefore(now, lateRegET) ? (
      showLateRegCountdown ? (
        timeLeft ? (
          <div className="flex flex-row items-center gap-1 text-xs">
            Reg. ends in
            <div className="bg-error-secondary/20 p-1 rounded-200 min-w-13 flex items-center justify-center">
              <p className="text-error-primary text-xs">{timeLeft}</p>
            </div>
          </div>
        ) : (
          <div>Registration Ended</div>
        )
      ) : (
        <div>
          {isToday(startTime) ? "Registration" : "Reg."} ends
          {isToday(startTime)
            ? ` at ${timeFormatted}`
            : isTomorrow(startTime)
            ? ` tomorrow at ${timeFormatted}`
            : ` on ${dateFormatted} ${timeFormatted}`}
        </div>
      )
    ) : isToday(startTime) ? (
      `Begins today at ${timeFormatted}`
    ) : isTomorrow(startTime) ? (
      `Begins tomorrow at ${timeFormatted}`
    ) : (
      `Begins at ${dateFormatted}`
    ); // or `Begins on ${dateFormatted} at ${timeFormatted}`;
  }
);
